module.exports = __webpack_public_path__ + "media/images/at-10882c436879f7ccfc11a379e14fa231.svg";